import type { Accounts } from '@aviata/platform-types';
import type { GroupedOffer } from '@aviata/platform-client';
import type { mapFlight } from './lib/map-flights';

export type MappedFlight = ReturnType<typeof mapFlight>;
export type MappedSegment = MappedFlight['segments'][number] & {
  label?: Accounts.Order.Label;
  durationTxt?: string;
};
export type MappedSegmentPoint = MappedSegment['dep'];
export type MappedSegmentStopLocation = NonNullable<
  MappedSegment['stops']['locations']
>[number];
export type ExpandedAirline = {
  iata: string;
  title: string;
};
export type MappedOffer = Omit<GroupedOffer, 'flights'> & {
  flights: MappedFlight[];
};

export enum NoteColor {
  green = 'green',
  orange = 'orange',
}
